import { ExecutionContext } from "../..";
import { WindowLocationWrapper } from "../window_wrapping/WindowLocationWrapper";
import { AnalyticsPageNameProvider } from "./AnalyticsPageNameProvider";

export class DefaultAnalyticsPageNameProvider
	implements AnalyticsPageNameProvider
{
	constructor(private readonly windowLocation: WindowLocationWrapper) {
		// do nothing
	}

	providePageName(executionContext: ExecutionContext): string | undefined {
		const { pageName, productCode, isPaymentPage = false } = executionContext;

		let analyticsPageName: string | undefined = undefined;
		if (pageName !== undefined) {
			analyticsPageName = pageName === "" ? undefined : pageName;
		} else if (
			this.windowLocation.pathname === "/contracts/orders/index.aspx"
		) {
			analyticsPageName = "Payment";
		} else if (productCode !== undefined && productCode.length > 0) {
			const pageNameSuffix = this.windowLocation.pathname.includes("preview")
				? " Preview"
				: " Index";
			analyticsPageName = productCode + pageNameSuffix;
		}

		if (analyticsPageName === "Payment" || isPaymentPage) {
			analyticsPageName += " Already Purchased";
		}

		return analyticsPageName;
	}
}
